export const ACTION_TYPES = {
  SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
  SET_PAGE: 'SET_PAGE',
  SET_ORDER_BY: 'SET_ORDER_BY',
  SET_ORDER_DIRECTION: 'SET_ORDER_DIRECTION'
}

export const DEFAULT_PAGE_SIZE = 25
